import {EyeOption} from '@/forecast-app/shared/components/changeview/show-hide-columns/ShowHideColumnsModal';
import {useCallback, useMemo} from 'react';
import {useTimesheetTableContext} from '../TimesheetTableContext';
import {useStoredState} from '@/forecast-app/shared/hooks/useStoredState';

export const TIMESHEET_OPTION_STORAGE_KEY = 'timesheet-options';

type TimesheetColumnEyeOptions = {
	eyeOptions: EyeOption[];
	setEyeOptions: (newOptions: EyeOption[]) => void;
};

export const useTimesheetColumnEyeOptions = (): TimesheetColumnEyeOptions => {
	const {columnDefinitions} = useTimesheetTableContext();
	const [eyeOptionState, setEyeOptionState] = useStoredState<Record<string, boolean>>(TIMESHEET_OPTION_STORAGE_KEY, {});

	const eyeOptions = useMemo(
		() =>
			columnDefinitions
				.filter(c => c.toggleable)
				.map(column => ({
					name: column.id,
					translationId: column.translationId,
					displayName: column.displayName,
					checked: eyeOptionState?.[column.id] ?? column.visible,
				})),
		[columnDefinitions, eyeOptionState]
	);

	const setEyeOptions = useCallback(
		(newOptions: EyeOption[]) => {
			const savedOptionValues = Object.fromEntries(newOptions.map(option => [option.name, option.checked]));
			setEyeOptionState(prev => ({
				...prev,
				...savedOptionValues,
			}));
		},
		[setEyeOptionState]
	);

	return {eyeOptions, setEyeOptions};
};
